import { requestConstantsMaker } from '../helper';

export const GET_ALL_COURSE_CLASS = requestConstantsMaker('GET_ALL_COURSE_CLASS');
export const GET_COURSE_CLASS = requestConstantsMaker('GET_COURSE_CLASS');